import { Component } from '@angular/core';

@Component({
    selector: 'help-documents-page',
    templateUrl: './help-documents.page.html',
    styleUrls: ['./help-documents.page.scss']
})
export class HelpDocumentsPage {

}